module.exports = __webpack_public_path__ + "img/blue-shirt.a7b83771.jpg";